$(document).foundation();
moment.locale('fr');

//&nbsp;&nbsp;<i class=\"fa fa-paper-plane-o\" aria-hidden=\"true\"></i>
//On focus add label class for manuscrit animation
$('.HeroPublish .wpcf7-form-control').focus(function() {
    var $this = $(this);
    var text_value = $this.val();
    if (text_value == '') {
        $this.parent().siblings().filter('label, .bar').addClass("active");
    }
}).blur(function() {
    var $this = $(this);
    var text_value = $this.val();
    if (text_value == '') {
        $this.parent().siblings().filter('label, .bar').removeClass("active");
    }
});

$(window).on('load resize orientationChange', Foundation.util.throttle(function() {
    //var equalizer = new Foundation.Equalizer($('[data-equalizer]')); //pb height
    $('.data-equalizer-img img').css('height', '100%');
}, 100));

$(function() {
    $(".lazyload").lazyload({
        threshold: 500,
        effect: "fadeIn"
    });
});

$('.HeroBannieres-slick').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    responsive: []
});

$('.HeroNew-slick').slick({
    //centerMode: true,
    //centerPadding: '60px',
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    //adaptiveHeight: true,
    responsive: [{
            breakpoint: 1023,
            settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 539,
            settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.HeroRelated-slick').slick({
    //centerMode: true,
    //centerPadding: '60px',
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    //adaptiveHeight: true,
    responsive: [{
            breakpoint: 1281,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 1023,
            settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 539,
            settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$('.avis-auteurs-slide').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
});

$('.avis-livres-slide').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    cssEase: 'linear'
});


/////////////////////////////////////////////
/////////////Form validation////////////////
///////////////////////////////////////////
$(document).ready(function() {
    $("#search-button").click(function() {
        $("#search-form").submit();
    });
});


/////////////////////////////////////////////
/////////////////Lightbox///////////////////
///////////////////////////////////////////
$('.gallery a').simpleLightbox();


/////////////////////////////////////////////
//////////////Event calendar////////////////
///////////////////////////////////////////
jQuery(document).ready(function($) {
    var eventId = null;
    if ($('#eventId').length) {
        eventId = $("#eventId").data('eventid');
    }

    $('#Event').gCalReader({
        calendarId: 'editionsdupantheon@gmail.com',
        apiKey: 'AIzaSyCb11isaU6GAsiq0uPICyMTI3xP2ZMBCxU',
        errorMsg: 'Pas d\'évènements à venir',
        maxEvents: 8,
        futureEventsOnly: true,
        sortDescending: false,
        eventId: eventId
    });
});

/////////////////////////////////////////////
/////////////Fullcalendar///////////////////
///////////////////////////////////////////
$(document).ready(function() {

    $('#calendar').fullCalendar({

        header: {
            left: 'prev',
            center: 'title',
            right: 'next'
        },

        defaultView: 'listWeek', //listYear, listMonth, listWeek, listDay

        displayEventTime: true, // don't show the time column in list view

        googleCalendarApiKey: 'AIzaSyCb11isaU6GAsiq0uPICyMTI3xP2ZMBCxU',

        events: 'editionsdupantheon@gmail.com',

        eventClick: function(calEvent, jsEvent, view) {
            //console.log(calEvent);

            var a = '';
            //var startdate = calEvent.start.dateTime || calEvent.start.date ||'';
            //a ='<div class="Event-date"><strong>' + moment(startdate).format("D MMMM YYYY") + '</strong></div><br>';
            if (calEvent.description) {
                a += '<div class="Event-description">' + calEvent.description + '</div><br>';
            }
            if (calEvent.location) {
                a += '<div class="Event-location"><em>' + calEvent.location + '</em></div>';
            }

            swal({
                title: calEvent.title,
                //text: calEvent.content.replace(/<(?:.|\s)*?>/gm,"")
                text: a,
                html: true,
                showConfirmButton: true
            });
            return false;
        },

        loading: function(bool) {
            $('#loading').toggle(bool);
        }

    });

});

/////////////////////////////////////////////
/////////////Scroll Magic////////////////////
///////////////////////////////////////////
$(function() {

    // Init ScrollMagic Controller
    var scrollMagicController = new ScrollMagic.Controller();

    if ($('#HeroCollections').length) {
        var tween_collections = new TimelineMax();

        tween_collections
            .from($('.HeroCollections ul li'), 1.4, {
                transform: "translate(0,0)",
                ease: Power1.easeOut
            }, '-=0.2');

        var scene_collections = new ScrollMagic.Scene({
                triggerElement: "#HeroCollections",
                triggerHook: 'onEnter',
                offset: 203,
                duration: "80%"
            })
            .setTween(tween_collections)
            .addTo(scrollMagicController);
    }

    // Add debug indicators fixed on right side
    //scene_collections.addIndicators();

    if ($('.title-bar').length) {
        var i1 = 0;
        var i2 = 0;
        new ScrollMagic.Scene()
            .addTo(scrollMagicController)
            .on("update", function() {
                var x1 = scrollMagicController.info("scrollDirection");
                var x2 = $(window).scrollTop() + 1;
                var x3 = 300;
                if (x1 == "REVERSE" && x2 >= x3 && i1 == 0) {
                    TweenMax.fromTo(".title-bar", 0.3, {
                        top: "-73px",
                    }, { top: "0px", backgroundColor: "rgba(255,255,255,.85)", ease: Linear.easeNone });
                    //TweenMax.to(".title-bar a", 0.3, {color: "#333", ease: Linear.easeNone});
                    i1++;
                    i2 = 0;
                }
                if (x1 == "FORWARD" && x2 > x3 && i2 == 0) {
                    TweenMax.fromTo(".title-bar", 0.3, { top: "0px", backgroundColor: "rgba(255,255,255,.85)" }, {
                        top: "-73px",
                        ease: Linear.easeNone
                    });
                    i1 = 0;
                    i2++;
                }
                if (x2 < x3 && i2 == 0) {
                    TweenMax.to(".title-bar", 0.3, { backgroundColor: "rgba(255,255,255,.85)", ease: Linear.easeNone });
                    i1++;
                    i2 = 0;
                }
            });
    }
});


/////////////////////////////////////////////
/////////////WP Wordpress///////////////////
///////////////////////////////////////////
jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

    // Makes sure last grid item floats left
    jQuery('.archive-grid .columns').last().addClass('end');

    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
            jQuery(this).wrap("<div class='widescreen flex-video'/>");
        } else {
            jQuery(this).wrap("<div class='flex-video'/>");
        }
    });

});


/////////////////////////////////////////////
//////// Track Google Analytics Events /////
///////////////////////////////////////////
document.querySelectorAll('.gtag').forEach(function(gtagElement) {
    gtagElement.addEventListener("click", function(e) {
        e.preventDefault();
        //console.log(this);

        var action = this.dataset.action;
        var category = this.dataset.category;
        var label = this.dataset.label;
        var value = this.dataset.value;
        var href = this.getAttribute('href');

        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value,
            'event_callback': function() {
                window.location = href;
            }
        });
    })
})